"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const http_1 = require("./http");
const storage_service_1 = require("./storage-service");
const authentication_1 = require("./authentication");
const host_cache_1 = require("./host-cache");
/**
 * Config class to change main URL params for the cloud-link platform.  If no declarative objects are given, Options will attempt to solicit defaults from the environment.
 * @class Config
*/
class Config {
    static get storage() {
        return Config._store || (Config._store = Config.getDefaultStorage());
    }
    static set storage(value) {
        Config._store = value;
    }
    static get fetch() {
        return Config._httpFetch || (Config._httpFetch = Config.getFetch());
    }
    static set fetch(value) {
        Config._httpFetch = value;
    }
    static get http() {
        return Config._http || (Config._http = new http_1.Http(Config.fetch, requestTimeoutMilliseconds => (requestTimeoutMilliseconds || Config.requestTimeoutMilliseconds), {
            appInfo: Config.appInfo,
        }));
    }
    static set http(value) {
        Config._http = value;
    }
    static get authentication() {
        if (!Config._auth) {
            Config.authentication = new authentication_1.AuthenticationService({
                cloud: Config.cloud,
                stage: Config.stage,
                http: Config.http,
                store: Config.storage,
            });
            // Note (JQ):  slimy hack to use shared cache without a recursive death spiral
            const authServiceRequester = Config._auth.serviceRequester;
            authServiceRequester.hostCache = Config.hostCache;
        }
        return Config._auth;
    }
    static set authentication(value) {
        Config._auth = value;
        if (value) {
            Config.httpService = new authentication_1.HttpService({
                http: Config.http,
                tokenStore: Config.authentication,
            });
            Config.hostCache = new host_cache_1.HostCache({
                http: Config.httpService,
            });
        }
    }
    static get httpService() {
        if (!Config._httpService) {
            Config.authentication;
        }
        return Config._httpService;
    }
    static set httpService(value) {
        Config._httpService = value;
    }
    static get notifications() {
        return Config._notifications;
    }
    static set notifications(value) {
        Config._notifications = value;
    }
    static get hostCache() {
        return Config._hostCache || (Config._hostCache = new host_cache_1.HostCache({}));
    }
    static set hostCache(value) {
        Config._hostCache = value;
    }
    static createServiceUrl(params) {
        const cloud = (params.cloud || Config.cloud || 'public').toLowerCase();
        const stage = params.stage || Config.stage || 'live';
        const stageSuffix = stage === 'live' ? '' : '-' + stage;
        const cloudSuffix = cloud === 'public' ? '' : '.' + cloud;
        return `https://${params.service}${stageSuffix}${cloudSuffix}.api.mitel.io/${params.version}`;
    }
    static getDefaultStorage() {
        if (typeof localStorage !== 'undefined') {
            return new storage_service_1.StorageService(localStorage);
        }
        else {
            return undefined;
        }
    }
    static getFetch() {
        if (typeof fetch !== 'undefined') {
            if (typeof window !== 'undefined') {
                return {
                    fetch: (rq, options) => fetch.call(window, rq, options)
                };
            }
            else {
                return {
                    fetch: fetch
                };
            }
        }
        else {
            throw new Error('Unable to get fetch function');
        }
    }
}
exports.Config = Config;
Config.requestTimeoutMilliseconds = 0;
//# sourceMappingURL=config.js.map